import { withInstall } from '@ll-plus/utils'

import VerticalLayout from './src/vertical-layout.vue'

export const LlVerticalLayout = withInstall(VerticalLayout)
export default LlVerticalLayout
export * from './src/vertical-layout'

declare module 'vue' {
  export interface GlobalComponents {
    LlVerticalLayout: typeof VerticalLayout
  }
}
